import { theme } from './theme';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Theme, ThemeColors } from './types';

export const useCustomTheme = (colors: ThemeColors): Theme => ({
  ...theme,
  colors,
});
